// Logger bootstrap — lives in core/ because it must initialize before modules load
export { logger, createChildLogger, setLoggerInstance, hasPinoPretty } from './proxy.js'
export { getLoggerConfig, loggerEnv } from './config.js'
export { initLoggerService, getLoggerService, resetLoggerService, getPinoLogger, captureExceptionSafe } from './service.js'
export { LogDebouncer } from './debounce.js'
export type { LoggerConfig, LoggerService } from './types.js'
